import ENV from "app/utils/ENV";
import { Vibration } from "react-native";
import * as Haptics from "expo-haptics";

let haptics = {
  success() {
    Haptics.notificationAsync(Haptics.NotificationFeedbackType.Success);
  },
  error() {
    Haptics.notificationAsync(Haptics.NotificationFeedbackType.Error);
  },
  warning() {
    Haptics.notificationAsync(Haptics.NotificationFeedbackType.Warning);
  },
  warn() {
    Haptics.notificationAsync(Haptics.NotificationFeedbackType.Warning);
  },
  light() {
    Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light);
  },
  medium() {
    Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Medium);
  },
  heavy() {
    Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Heavy);
  },
  vibrate() {
    Vibration.vibrate();
  },
};

if (ENV.WEB) {
  Object.keys(haptics).forEach((k) => {
    haptics[k] = () => console.log(`haptics: "${k}"`);
  });
}

export default haptics;
